<template>
    <div v-if="returnIsShowHeader.show" class="floor-header">
        <template v-if="returnIsShowHeader.title">
        <!-- <template v-if="false"> -->
            <div :class="['head-wrap',{'head-wrap-border':!info.bg_image}]">
                <div class="left-head-warp">
                    <el-image @click="$router.pushToTab(info.value.more.value.link)" :src="$img(info.value.titleImg.value.url)"
                        fit="scale-down"></el-image>
                    <div>
                        <h2 @click="$router.pushToTab(info.value.title.value.link.url)" :style="{ color: info.value.title.value.color }">
                            {{ info.value.title.value.text }}
                        </h2>
                        <span class="warp-title" :style="{ color: info.value.subTitle.value.color }" 
                        @click="$router.pushToTab(info.value.subTitle.value.link.url)">
                            {{ info.value.subTitle.value.text }}    
                        </span>
                    </div>
                </div>
                <div class="right-head-warp">
                    <div @click="$router.pushToTab(info.value.more.value.link.url)" :style="{ color: info.value.more.value.color }">
                        <span :style="{ color: info.value.more.value.color }">
                            {{ info.value.more.value.text.replace('>','') }}
                        </span>
                        <i :style="{ color: info.value.more.value.color }" class="icon el-icon-arrow-right"></i>
                    </div>
                </div>
            </div>
        </template>
        <template v-if="returnIsShowHeader.banner">
            <div class="header-banner">
                <el-image @click="$router.pushToTab(info.value.titleImg.value.link.url)" :src="$img(info.value.titleImg.value.url)" fit="scale-down"></el-image>
            </div>
        </template>
    </div>
</template>

<script>
export default {
    name: "floor-header",
    components: {},
    props: {
        info: {
            type: Object,
            default: () => {}
        }
    },
    data() {
        return {}
    },
    created() {},
    mounted() {
        
    },
    computed: {
        returnIsShowHeader(){
            let returnBool = {
                show:false,
                title:false,
                banner:false,
            };
            let bool = (JSON.stringify(this.info) !== '{}'?true:false);
            if(bool){
                let val1 = (this.info.value.title.value.text);
                let val2 = (this.info.value.titleImg.value.url);
                let valBool = (val1 || val2);
                if(valBool){
                    returnBool.show = true;
                }
                if(val1){
                    returnBool.title = true;
                }else if(val2){
                    returnBool.banner = true;
                }
            }
            return returnBool;
        }
    },
    methods: {}
}
</script>

<style lang="scss">
    .floor-header{
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        position: relative;
        z-index: 2;
        .head-wrap {
            box-sizing: border-box;
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 20px;
            width: 100%;
        }
        .head-wrap-border{
            border-bottom: 1px solid #f9f9f9;
        }

        .head-wrap {
            .left-head-warp {
                display: flex;
                align-items: center;
                gap: 6px;
                .el-image {
                    width: 30px;
                    height: 30px;
                }
                h2 {
                    font-size: calc(var(--global-size) + 4px);
                    line-height: 1;
                    cursor: pointer;
                    font-weight: bold;
                    color: #333;
                }
                >div{
                    display: flex;
                    align-items: baseline;
                    gap: 6px;
                }
            }

            span {
                color: #b0b0b0;
                font-size: var(--global-size);
                line-height: 1;
                cursor: pointer;
            }

            .el-icon-arrow-right {
                font-size: 16px;
            }
        }
        .header-banner{
            display: flex;
            justify-content: center;
            align-items: center;
            >.el-image{
                width: 100%;
            }
        }
    }
</style>
